import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { Box, Button, Flex, H2, Separator } from 'styling/GlobalStyles'
import { ICycleState } from 'types/cycles.interface'
import { components } from '../TaskTemplates/taskData'
import { CloseIcon } from 'assets/icons/CloseIcon'

export const SingleComponent = ({ index, state, setState, view }: { index: number, view?: boolean, setState: React.Dispatch<React.SetStateAction<ICycleState>>, state: ICycleState }) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy.components[index].name = e.target.value
            return copy
        })
    }

    const getDefaultValue = () => {
        return state.components[index].component
    }

    const handleAddStep = () => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy.components.push({
                name: '',
                component: null,
            })
            return copy
        })
    }

    const handleSelect = (value: ISelectValue) => {

        setState(prev => {
            const copy = structuredClone(prev)
            copy.components[index].component = value.value
            return copy
        })

    }

    const handleRemove = () => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy.components.splice(index, 1)
            return copy
        })
    }

    return <Flex column gap='1rem' alignEnd>
        < Box style={{ height: 'min-content' }} ><Flex style={{ pointerEvents: view ? 'none' : 'all' }} gap='1rem' width='15rem' column>
            <Flex width='100%' between center >
                <H2>Component: {index + 1}</H2>
                <CloseIcon onClick={handleRemove} />
            </Flex>
            <Input
                type='text'
                value={state?.components[index]?.name}
                onChange={handleChange}
                placeholder='Enter component name'
                labelText='Component name'
                invalid={state?.components[index]?.name?.length < 2 ? 'true' : ''}
                nomarg
            />

            <HonestSelectInput
                name='component'
                onChange={(value: ISelectValue) => handleSelect(value)}
                labelText='Component type'
                defaultValue={getDefaultValue()}
                options={components.map(c => ({ label: c.name, value: c.component }))}
                nomarg
            />
        </Flex>
        </Box>
        {state.components.length - 1 == index && !view && <Button orange onClick={handleAddStep}>Add Component</Button>}
    </Flex>

}